import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";

import LikedBy from "./LikedBy";

const styles = theme => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    margin: "0 0"
  }
});

class ViewLikedBy extends React.Component {
  state = {};

  render() {
    const { classes, likeData } = this.props;

    return (
      <div className={classes.root}>
        <LikedBy likeData={likeData} />
      </div>
    );
  }
}

ViewLikedBy.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(ViewLikedBy);
